module.exports = __webpack_public_path__ + "img/neptune.be5030ca.webp";